<template>
  <svg :class="customClass" width="21" height="14" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 9.84487V8.18137H2.18275V9.84487H0.5ZM0.5 6.14312V4.47962H2.18275V6.14312H0.5ZM0.5 2.45062V0.796875H2.18275V2.45062H0.5ZM4.375 9.75838V8.25837H7.84625V9.75838H4.375ZM4.375 6.06612V4.56612H16.6538V6.06612H4.375ZM4.375 2.37387V0.873874H16.6538V2.37387H4.375ZM13.8057 13.6526L9.9885 9.83537L11.0577 8.76612L13.8057 11.5141L19.273 6.04687L20.3267 7.13137L13.8057 13.6526Z"
      fill="#7E499D"
    />
  </svg>
</template>

<script>
export default {
  name: "ConditionallyAcceptedIcon",
  props: {
    customClass: {
      type: String,
      default: "w-6 h-6",
    },
  },
};
</script>
